/**
 * Dev-only preview toggle. Enable any of:
 *   - VITE_DEV_PREVIEW=true   (in packages/webapp/.env or .env.local)
 *   - ?dev=1                  (query string, ad-hoc)
 *   - localStorage.devPreview = '1'   (sticky in browser session)
 *
 * Logged once on boot so it's obvious in the console why screens render.
 */
function compute(): boolean {
  try {
    const envFlag = import.meta.env.VITE_DEV_PREVIEW;
    if (envFlag === 'true' || envFlag === '1') return true;
  } catch {
    // import.meta unavailable in some environments
  }
  if (typeof window === 'undefined') return false;
  try {
    if (new URLSearchParams(window.location.search).get('dev') === '1') {
      window.localStorage.setItem('devPreview', '1');
      return true;
    }
  } catch {
    // ignore
  }
  try {
    if (window.localStorage.getItem('devPreview') === '1') return true;
  } catch {
    // ignore
  }
  return false;
}

export const DEV_PREVIEW = compute();

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.info(
    `[torian] DEV_PREVIEW = ${DEV_PREVIEW}  (env=${import.meta.env.VITE_DEV_PREVIEW ?? 'undefined'})`,
  );
}
